module.exports = __webpack_public_path__ + "media/kannym.a572de0d.mp3";